import { cn } from "@/lib/utils";

const LOGO_SRC = "/mpt.png";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

const sizeHeightMap = {
  sm: "h-7",
  md: "h-9",
  lg: "h-12",
} as const;

export const Logo = ({ className, size = "md" }: LogoProps) => {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img
        src={LOGO_SRC}
        alt="My Professional Tax"
        className={cn("w-auto object-contain", sizeHeightMap[size])}
        height={size === "sm" ? 28 : size === "md" ? 36 : 48}
      />
    </div>
  );
};

// Compact logo for mobile or constrained spaces
export const LogoMark = ({ className, size = "md" }: Omit<LogoProps, "showText">) => {
  return (
    <img
      src={LOGO_SRC}
      alt="My Professional Tax"
      className={cn("object-contain object-center", sizeHeightMap[size], "w-auto max-w-[theme(spacing.20)]", className)}
      height={size === "sm" ? 28 : size === "md" ? 36 : 48}
    />
  );
};
